import { Box, Button, Typography } from "@mui/material";
import { border } from "@mui/system";

export default function ActionChip({ action }) {
  const getStyles = () => {
    switch (action) {
      case "Modificar":
        return {
          backgroundColor: "#FFFFFF",
          border: "1px solid #0000003B",
          color: "#000000DE",
        };
      case "Descartar":
        return {
          backgroundColor: "#002878",
          color: "#FFFFFF",
          borderRadius: "8px",
        };
      case "Eliminar":
        return {
          backgroundColor: "#FFFFFF",
          color: "#000000DE",
          border: "1px solid #0000003B",
          borderRadius: "8px",
        };
      default:
        return {
          backgroundColor: "#FFFFFF",
          color: "#000000DE",
          border: "1px solid #0000003B",
          borderRadius: "8px",
        };
    }
  };
  const styles = getStyles();

  const handleToggle = () => {};
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <Button
        onClick={handleToggle}
        sx={{
          padding: "10px 16px",
          height: "32px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          ...styles,
        }}
      >
        <Typography
          variant="body2"
          fontWeight={400}
          size="small"
          sx={{ color: "rgba(0, 0, 0, 0.87)" }}
        >
          {action}
        </Typography>
      </Button>
    </Box>
  );
}

const styles = {
  Modificar: {
    backgroundColor: "#FFFFFF",
    border: "1px solid #0000003B",
    color: "#000000DE",
  },
  Descartar: {
    backgroundColor: "#002878",
    color: "#FFFFFF",
  },
};
